import {ChangeDetectorRef, Component, OnInit, ViewChild, ViewRef} from '@angular/core';
import {TdoTableV2Component} from '../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {ReferringDoctorDataModel} from '../configuration/referral-configuration/models/referring-doctor-data.model';
import {ReferralsService} from '../configuration/referral-configuration/referrals.service';
import {Globals} from '../../globals';
import {
    DataReferralDoctorsModel, 
    ReferralDataModel,
    ReferringDoctorFilter, TDOReferringDataDoctorModel
} from '../configuration/referral-configuration/models/referral-data.model';
import {ReferralFilterModel} from '../configuration/referral-configuration/models/referral-filter.model';
import {DoctorsComponent} from '../configuration/doctors/doctors.component';
import {SchedulerComponent} from '../../main-interface/scheduler/scheduler.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {PatientSearchModel} from '../../models/patient/patient-search.model';
import {PatientService} from '../../modules/patient/patient.service';
import {DxSchedulerComponent} from 'devextreme-angular';
import {TdoSimpleNoteComponent} from '../../tdo-controls/common/tdo-simple-note/tdo-simple-note.component';
import {PatientDialogDataModel} from '../patient/patient-dialog-data.model';
import {InsuranceManagementComponent} from '../insurance/insurance-management/insurance-management.component';
import {PatientEditComponent} from '../patient/patient-edit/patient-edit.component';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../services/static-data.service';
import {TdoDropdownModel} from '../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {DialogService} from '../../services/dialog.service';
import {PatientDataModel} from '../../models/patient/patient-data.model';
import {ContactDataModel} from '../../models/person/contact-data.model';
import {ContactCommsDataModel} from '../../models/person/contact-comms-data.model';
import {CommMethodEnum} from '../../models/enum/comm-method.enum';
import {PatientDoctorDataModel} from '../../models/patient/patient-doctor-data.model';
import {DoctorSpecialtyDataModel} from '../../models/doctors/doctor-specialty-data.model';
import {DoctorDataModel} from '../../models/doctors/doctor-data.model';
import {InsuranceDataModel} from '../../models/insurance/insurance-data.model';
import {dataPatientInsurance} from '../ar/_models/ar.models';
import {MessagingConstants} from '../../models/MessagingConstants';
import {MessagingService} from '../../services/messaging.service';
import {ClientLocationDataModel} from '../../models/clients/client-location-data.model';
import {OfficeLocationsService} from '../configuration/office-locations/office-locations.service';
import {DatePipe} from '@angular/common';
import {DataAppointmentModel} from '../../models/appointments/data-appointment.model';
import {UserService} from '../../services/user.service';
import {SchedulingService} from '../scheduling/scheduling.service';
import {DoctorsService} from '../../services/doctors.service';
import {EnumReferralStatus} from '../../models/enum/enum-referral-status';
import {Already_Have_Appointment, Constants, Contact_Patient, Patient_Will_Contact_Office} from '../../constants';
import {ReferralMatchListComponent} from './referral-match-list/referral-match-list.component';
import {CommLocationEnum} from '../../models/enum/comm-location.enum';
import Utils from '../reports/Utils/utils';
import {ActivatedRoute, Router} from '@angular/router';
import {forkJoin, of} from 'rxjs';
import {catchError, finalize, map, switchMap} from 'rxjs/operators';
import {TdoPatientSearchComponent} from '../../tdo-controls/tdo-patient-search/tdo-patient-search.component';
import {
    TdoNoteAssociatedObject,
    TdoNoteSaveModel
} from '../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import {NoteCategoryEnum} from '../../models/enum/note-category.enum';
import {NoteTypeEnum} from '../../models/enum/note-type.enum';
import {NotesService} from '../../services/notes.service';
import {TdoNoteQueryModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {InsuranceService} from '../insurance/insurance.service';
import { UiService } from '../../services/ui.service';

export interface enumAppointmentDuration {
    id: string;
    value: string;
    min: number;
}


@Component({
  standalone: false,
    selector: 'app-referral-manager',
    templateUrl: './referral-manager.component.html',
    styleUrls: ['./referral-manager.component.scss']
})


export class ReferralManagerComponent implements OnInit {
    @ViewChild('table1') table1: TdoTableV2Component;
    // @ViewChild('patientSearchInput') patientInputSearch: ElementRef;

    @ViewChild('simpleNote') simpleNote: TdoSimpleNoteComponent;
    @ViewChild('tps') patientInputSearch: TdoPatientSearchComponent;

    @ViewChild('tdoScheduler', {static: false}) set tdoxScheduler(content: DxSchedulerComponent) {
        if (content) {
            this.tdoScheduler = content;
        }
    }

    tdoScheduler: DxSchedulerComponent;
    referrals: ReferralDataModel[] = [];
    referralsFilter: ReferralDataModel[] = [];
    referringDocs: ReferringDoctorDataModel[] = null;
    procedures: any[] = [];
    otherServices: any[] = [];
    newMode = false;
    isPopupVisible = false;
    clickedImage: string = '';
    imageTooltip: string = '';
    referralSearch: string;
    isLoading: boolean = true;
    errorLoading: boolean = false;
    referralLoading: boolean = false;
    referralNote:  TdoNoteSaveModel;

    newDoc: ReferringDoctorDataModel = null;
    selectedRef: ReferralDataModel;
    selectedDoc: ReferringDoctorDataModel;
    othTreatments: string[] = [];
    treatmentsSelected: string[] = [];
    referralFilter: ReferralFilterModel = new ReferralFilterModel();
    referralStatus: EnumValidValueItemModel[] = [];
    selectedReferralstatus: EnumValidValueItemModel;
    patientSearch: PatientSearchModel = new PatientSearchModel();
    referringDoctorSearchFilter: ReferringDoctorFilter = new ReferringDoctorFilter();
    validTDOXpatientID: string = null;
    validTDOXReferringDrID: string = null;
    validTDOxInsuranceID: string = null;
    EnumReferralStatusPending = EnumReferralStatus.Pending;
    EnumReferralStatusAppoitmet = EnumReferralStatus.Appointment;
    // patient search variables
    isShowPatientSearch = false;
    searchString: string = '';
    patientSearchList: PatientSearchModel[] = [];
    dataReferralDoctor: DataReferralDoctorsModel = new DataReferralDoctorsModel();
    // Match and new Items to select
    matchReferralDoctor: boolean = false;
    // isMatchReferralDoctorByQuery: boolean = false;
    isMatchPatientByQuery: boolean = false;
    matchReferralPatient: boolean = false;
    matchReferralInsurance: boolean = false;
    matchPatientFullName: string;
    listTDOReferralDoctor: TDOReferringDataDoctorModel[] = [];
    listTDOProvidersDoctors: DoctorDataModel[] = [];
    selectedTDOReferralDoctor: TDOReferringDataDoctorModel;

    listMatchTDOPatients: PatientSearchModel[] = [];
    listMatchTDOInsurances: dataPatientInsurance[] = [];
    selectedTDOReferralPatient: PatientSearchModel;
    selectedTDOReferralInsurance: InsuranceDataModel;
    dataDoctorSpecialties: DoctorSpecialtyDataModel[] = [];

    // appointment section
    locations: ClientLocationDataModel[] = [];
    selectedLocation: ClientLocationDataModel;
    appointmentStartDateTime: string;
    appointmentEndDateTime: string;
    appointmentDate: string;
    appointmentStartTime: string = '08:00 am';
    appointmentDuration: string;  // enumAppointmentDuration;
    Appointment: DataAppointmentModel;
    referralInsuranceCardNote: TdoNoteSaveModel;
    matchReferralInsuranceName: string;
    urlReferralId: string;

    constructor(
        public apiService: ReferralsService,
        public patientService: PatientService,
        public globals: Globals,
        private dialog: MatDialog,
        private staticDataService: StaticDataService,
        private dialogService: DialogService,
        private messagingService: MessagingService,
        private officeLocationService: OfficeLocationsService,
        private userService: UserService,
        private schedulingService: SchedulingService,
        private doctorsService: DoctorsService,
        private router: Router,
        private datePipe: DatePipe,
        private notesService: NotesService,
        private insuranceService: InsuranceService,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private uiService: UiService
    ) {
        this.route.params.subscribe(params => {
            // console.log('route params subscribe', params);
            this.urlReferralId = params['referralId'];
            // console.log('route params subscribe urlReferralId', this.urlReferralId);
            if (this.urlReferralId && this.referrals.length > 0) {
                // console.log('preload referral from list');
                this.selectedRef = null;
                const preloadReferral = this.referrals.find(x => x.ReferralID === this.urlReferralId);
                if (preloadReferral) {
                    // console.log('preload referral found', preloadReferral);
                    this.selectRef(preloadReferral);
                } else {
                    // console.log('preload referral not found');
                    this.errorLoading = true;
                }
            }
        });
        this.apiService.getReferralDocs().subscribe(data3 => {
            this.referringDocs = data3;
        });

        // get list of TDO Referral Doctor
        this.apiService.getTDOReferringDoctors().subscribe(data => {
            if (data) {
                this.listTDOReferralDoctor = data;
                this.getPrimaryInformation();
            }
        });

        this.apiService.getTDOProviderDoctorReferredList().subscribe(data => {
            if (data) {
                this.listTDOProvidersDoctors = data;
                this.getReferralList(false);
            }
        });

        this.officeLocationService.getAllLocations().subscribe((locationsRes) => {
            this.locations = locationsRes;
        });
    }

    ngOnInit() {
        if (this.staticDataService.validValueItems && this.staticDataService.validValueItems.length > 0) {
            this.referralStatus = this.staticDataService.getValidValueItemsByValidValueName('enumReferralStatus');
            this.referralFilter.referralStatusID = EnumReferralStatus.Pending;
        } else {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.referralStatus = this.staticDataService.getValidValueItemsByValidValueName('enumReferralStatus');
                    this.referralFilter.referralStatusID = EnumReferralStatus.Pending;
                }
            });
        }
    // get list of TDO Referral Doctor
    }

    getDate(d: Date | string) {
        return new Date(d);
    }

    getLocalDate(d: Date | string): Date {
        const dateObj = typeof d === 'string' ? new Date(d + 'Z') : d;
        return dateObj;
    }


    getReferralList(isRefreshAction: boolean) {
        if (isRefreshAction) {
            this.apiService.getReferralDocs().subscribe(data3 => {
                this.referringDocs = data3;
            });
        }
        this.isLoading = true;
        this.selectedRef = null;
    this.apiService.getReferralList(this.referralFilter).subscribe(dataReferral => {
        if (dataReferral.length > 0) {
            this.referrals = dataReferral;
            let referralLoaded = false;
            if (this.urlReferralId) {
                // console.log('preload referral from url', this.urlReferralId);
                const preloadReferral = this.referrals.find(x => x.ReferralID === this.urlReferralId);
                if (preloadReferral) {
                    // console.log('preload referral found', preloadReferral);
                    this.selectRef(preloadReferral);
                    referralLoaded = true;
                }
                else {
                    this.errorLoading = true;
                }
            }
            if (!referralLoaded) 
                this.referralsFilter = this.referrals.filter(x => x.enumReferralStatusID === this.referralFilter.referralStatusID); // Filter by Pending.
            else
                this.referralsFilter = this.referrals;
        } else {
            this.referrals = [];
            this.referralsFilter = [];
            this.uiService.displayMessage('info','No referral requests found for the selected status.');
        }
        this.isLoading = false;
        if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
    });
    }


    selectRef(ref: ReferralDataModel) {
        // console.log('selectRef called', ref);
        this.selectedRef = null;
        this.validTDOXpatientID = null;
        this.globals.validTDOXpatientID = null;
        this.validTDOXReferringDrID = null;
        this.validTDOxInsuranceID = null;
        this.matchReferralInsuranceName = '';
        this.errorLoading = false;
        this.referralLoading = true;
        this.patientSearch.FirstName = ref.Patient_FirstName;
        this.patientSearch.LastName = ref.Patient_LastName;
        this.patientSearch.BirthDate = ref.Patient_DOB.toString();
        this.apiService.getReferralInformation(ref.ReferralID).pipe(
            switchMap((referralData: ReferralDataModel[]) => {
                // console.log('switchmap referralData', referralData);
                if (!referralData || referralData.length === 0) {
                    this.errorLoading = true;
                    return of(null);
                }

                // console.log('referralData', referralData);
                // console.log('ref', ref);
                this.selectedRef = ref = referralData[0];

                // console.log('selectedRef switchmap', this.selectedRef);
                this.referringDoctorSearchFilter.fullname = this.dataReferralDoctor.FullName = this.selectedRef.Referral_FullName;
                this.referringDoctorSearchFilter.phone = this.dataReferralDoctor.phone = this.selectedRef.Referral_phone;
                this.referringDoctorSearchFilter.email = this.dataReferralDoctor.email = this.selectedRef.Referral_email;
                this.dataReferralDoctor.Provider_DoctorID = this.selectedRef.ProviderID;
                this.dataReferralDoctor.RefDoctorID = this.selectedRef.RefDoctorID;
                this.dataReferralDoctor.DoctorId = this.selectedRef.DoctorID;

                return forkJoin([
                    this.apiService.getReferralDoctorForMatch(this.dataReferralDoctor),
                    this.apiService.getTreatments(this.dataReferralDoctor.Provider_DoctorID),
                    this.apiService.getProcedures(this.dataReferralDoctor.Provider_DoctorID)
                ]).pipe(
                    map(([drMatch, treatments, procedures]) => {
                        if (this.dataReferralDoctor.DoctorId !== null) {
                            this.dataReferralDoctor.FullName = this.selectedRef.ReferringTDO_FullName;
                            this.matchReferralDoctor = true;
                            this.dataDoctorSpecialties.push(this.selectedRef.ReferringTDO_Specialty);
                        } else {
                            if (drMatch) {
                                this.updateDataReferralDoctor(drMatch);

                            } else {
                                this.matchReferralDoctor = false;
                            }
                        }
                        this.otherServices = treatments;
                        this.procedures = procedures;
                        this.selectedDoc = this.referringDocs.find(doc => doc.RefDoctorID === this.selectedRef.RefDoctorID);
                        this.treatmentsSelected = this.selectedRef.ReferralTretmentIDsJSON.trim().split(' ');
                        this.othTreatments = this.selectedRef.ReferralOtherIDsJSON.trim().split(' ');
                        return true;
                    })
                );
            }),
            catchError(() => {
                this.errorLoading = true;
                this.selectedRef = null;
                return of(null);
            }),
            finalize(() => {
                this.referralLoading = false;
                if (!(this.cdr as ViewRef).destroyed) {
                    this.cdr.detectChanges();
                }
            })
        ).subscribe((loaded) => {
            // console.log('subscribe loaded', loaded);
            if (!loaded) {
                return;
            }
            // console.log('selectedRef subscribe', this.selectedRef);
            if (this.selectedRef.enumReferralStatusID === this.EnumReferralStatusAppoitmet && this.selectedRef.AppointmentID !== null) {
                // get appointment information and disable appointment form
                this.selectedLocation = this.locations.find(x => x.LOCID === this.selectedRef.AppointmentLOCID);
                this.appointmentStartDateTime = this.selectedRef.AppointmentStartDate !== null ? this.selectedRef.AppointmentStartDate.toString() : '';
                this.appointmentEndDateTime = this.selectedRef.AppointmentEndDate !== null ? this.selectedRef.AppointmentEndDate.toString() : '';
                const differenceValue = Utils.getDifferenceInMinutes(new Date(this.selectedRef.AppointmentEndDate), new Date(this.selectedRef.AppointmentStartDate));
                this.appointmentDuration = `${Math.abs(Math.round(differenceValue)).toString()} min`;  // this.enumAppointmentDuration.find(x => x.min === Math.abs(Math.round(differenceValue)));
            } else {
                this.selectedLocation = null;
                this.appointmentStartDateTime = null;
                this.appointmentEndDateTime = null;
                this.appointmentDuration = '';
            }

            if (this.selectedRef.PatientId === null) {
                this.apiService.getPatientByReferralData(this.patientSearch).subscribe(retData => {
                    if (retData.length === 0) {
                        this.isMatchPatientByQuery = false;
                        this.matchReferralPatient = false;
                        this.matchReferralInsurance = false;
                        // this.listMatchTDOPatients = [];
                        this.listMatchTDOInsurances = [];
                    }
                    if (retData.length === 1) { // Patient Match, set current Patient
                        this.setCurrentPatient(retData[0].PatientId, `${retData[0].FirstName} ${retData[0].MidName} ${retData[0].LastName}`, true);
                        this.isMatchPatientByQuery = true;
                        // get The insurance for the patient
                        // this.getInsuranceForPatient();
                    }
                    if (retData.length > 1) { // Select Patient from List
                        // this.listMatchTDOPatients = retData;
                        this.matchReferralPatient = false;
                        this.matchReferralInsurance = false;
                        this.isMatchPatientByQuery = false;
                        this.listMatchTDOInsurances = [];
                    }
                });
            } else {
                this.setCurrentPatient(this.selectedRef.PatientId, this.selectedRef.ReferringTDOPatient_FullName, false);
            }
        });
    }

    setCurrentPatient(PatientId: string, FullName: string, saveReferral: boolean) {
        this.matchReferralPatient = true;
        this.validTDOXpatientID = PatientId;
        this.matchPatientFullName = FullName;
        // update table referral with PatientID
        this.selectedRef.PatientId = PatientId;
        if (saveReferral) {
            this.apiService.saveDataReferralFrontDesk(this.selectedRef).subscribe(referral => {
            });
        }
        if (this.matchReferralDoctor === true) {
            // update match Doctor with match patient in tdo.dataPatientDoctors
            this.updateDataPatientDoctorRecord();
        }

        this.getInsuranceForPatient();
        // set currentPatient
        // this.patientService.setCurrentPatient(this.validTDOXpatientID);
        // this.globals.currentPatientId = this.validTDOXpatientID;
        // this.globals.currentPatientFullName = FirstName + ' ' + MidName + ' ' + LastName;
        this.messagingService.recursiveBroadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: this.validTDOXpatientID,
            clearCurrentQuery: false,
            Process: MessagingConstants.DO_NOT_LOAD_CASE_VIEW,
        });
        // console.log('setCurrentPatient referralLoading to false');
        this.referralLoading = false;
        if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
    }

    onCopyAttachments() {
        // console.log('copy attachments');

        this.apiService.copyAttachmentsToPatient(this.selectedRef.ReferralID).subscribe({
            next: res => {
                this.uiService.displayMessage('success', res);
            },
            error: () => {
                this.uiService.displayMessage('error','Failed to copy attachments. Please try again.');
            }
        });
    }

    onSearchPatientClick() {
        if (this.matchReferralDoctor !== true) {
            this.uiService.displayMessage('error','Please, Select or Create a new Referral Doctor');
            return;
        }

        this.isShowPatientSearch = !this.isShowPatientSearch;
        setTimeout(() => {
            this.patientInputSearch.focus();
        }, 100);
    }


    getInsuranceForPatient() {
        this.apiService.getInsuranceForPatient(this.validTDOXpatientID).subscribe(dataInsurance => {
            if (dataInsurance.dataPatientInsurances.length >= 1) {
                this.listMatchTDOInsurances = dataInsurance.dataPatientInsurances;
                const existsInsurance = this.listMatchTDOInsurances.find(x => x.PatientInsuranceNO === this.selectedRef.Insurance_Number);
                if (this.selectedRef.Insurance_Number !== '' && existsInsurance) {
                    this.validTDOxInsuranceID = existsInsurance.PatientInsuranceID;
                    this.matchReferralInsurance = true;
                    this.setReferralPatientInsurance(existsInsurance.dataInsurance.Description);
                } else if (this.selectedRef.PatientInsuranceID !== null) {
                    this.matchReferralInsurance = true;
                    this.matchReferralInsuranceName = this.listMatchTDOInsurances.find(x => x.PatientInsuranceID === this.selectedRef.PatientInsuranceID).dataInsurance.Description;
                } else {
                    // this.matchReferralPatient = false;
                    this.matchReferralInsurance = false;
                    this.listMatchTDOInsurances = [];

                }

            }
        });
    }

    setReferralPatientInsurance(Insurance: string) {
        this.selectedRef.PatientInsuranceID = this.validTDOxInsuranceID;
        this.apiService.saveDataReferralFrontDesk(this.selectedRef).subscribe(referral => {
            if (referral) {
                this.matchReferralInsuranceName = Insurance;
            }
        });
    }

    findPatientInsuranceOnList(event: any) {
        if (this.matchReferralPatient !== true) {
            this.dialogService.openConfirmDialog('Please, Select or Create a new Patient',
                false, false, 'Referral Management').subscribe((result) => {
                if (result === true) {
                    return;
                }
            });
        } else {
            const dialogRef = this.dialog.open(ReferralMatchListComponent, {
                width: '700px',
                height: '500px',
                panelClass: 'dialog',
                data: {
                    isInsurance: true,
                    isDialogMode: true,
                    Title: 'Select Patient Insurance',
                    listMatchTDOInsurances: this.listMatchTDOInsurances
                }
            }).afterClosed().subscribe((data) => {
                if (data) { // after, update PatientInsuranceID on ReferralTable
                    this.validTDOxInsuranceID = data.PatientInsuranceID;
                    this.matchReferralInsurance = true;
                    this.setReferralPatientInsurance(data.dataInsurance.Description);
                }
            });
        }
    }


    updateDataPatientDoctorRecord() {
        const dataPatientDoctor: PatientDoctorDataModel = new PatientDoctorDataModel();
        // dataPatientDoctor = new PatientDoctorDataModel();
        dataPatientDoctor.DoctorID = this.dataReferralDoctor.DoctorId;
        dataPatientDoctor.PatientId = this.validTDOXpatientID;
        dataPatientDoctor.isReferring = true;
        dataPatientDoctor.DoctorSpecId = this.dataDoctorSpecialties.length > 0 ? this.dataDoctorSpecialties[0].DoctorSpecId : Constants.emptyGuid;
        dataPatientDoctor.PracticeId = null;
        this.patientService.saveDataPatientReferralDoctor(dataPatientDoctor);
    }

    getPrimaryInformation() {
        this.listTDOReferralDoctor = this.listTDOReferralDoctor.map(obj => {
            const primaryPhone = obj.dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Phone && x.xauditDeleted === false);
            if (primaryPhone) {
                return {...obj, primaryPhone: primaryPhone.Address};
            }
            return {...obj, primaryPhone: ''};
        });

        this.listTDOReferralDoctor = this.listTDOReferralDoctor.map(obj => {
            const primaryEmail = obj.dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Email && x.xauditDeleted === false);
            if (primaryEmail) {
                return {...obj, primaryEmail: primaryEmail.Address};
            }
            return {...obj, primaryEmail: ''};
        });

        this.listTDOReferralDoctor = this.listTDOReferralDoctor.map(obj => {
            const fullName = `${obj.dataContact.FirstName ?? ''} ${obj.dataContact.LastName ?? ''}`;
            if (fullName) {
                return {...obj, FullName: fullName};
            }
            return {...obj, FullName: ''};
        });
    }

    remove(ref: ReferralDataModel) {
        this.apiService.removeReferral(ref.ReferralID).subscribe(data => {
            this.selectedRef = null;
            this.apiService.getReferralList(this.referralFilter).subscribe(dataReferral => {
                this.referrals = dataReferral;
            });
        }
        );
    }

    cancel(ref: ReferralDataModel) {
        if (ref === null) {
            this.dialogService.openConfirmDialog('Please, Select a Referral Request',
                false, false, 'Referral Management').subscribe((result) => {
                if (result === true) {
                    return;
                }
            });

        } else {
            if (ref.enumReferralStatusID !== EnumReferralStatus.Canceled) {
                this.dialogService.openConfirmDialog(`Are you sure to remove Referral for Patient:  ${ref.Patient_FirstName} ${ref.Patient_LastName} ?`).subscribe((result) => {
                    if (result === true) {
                        this.apiService.cancelReferral(ref.ReferralID).subscribe(data => {
                            const indexToRemove = this.referralsFilter.findIndex(x => x.ReferralID === ref.ReferralID);
                            if (indexToRemove !== -1) {
                                const updatedProperties = {enumReferralStatusID: EnumReferralStatus.Canceled};
                                // const referralCancelled = this.referralsFilter.map(x => x.enumReferralStatusID = EnumReferralStatus.Canceled);
                                this.referrals.forEach(item => {
                                    if (item.ReferralID === ref.ReferralID) {
                                        return {...item, ...updatedProperties};
                                    }
                                });
                                this.referralsFilter.splice(indexToRemove, 1);
                                this.getReferralList(false);
                            }
                            this.selectedRef = null;
                        }
                        );
                    }
                });
            }
        }
    }

    enlargeImage(img: any) {
        // console.log(img);
        const a = document.createElement('a');
        a.href = img.url;
        a.download = img.name;
        document.body.appendChild(a);
        a.click();
    }

    changeStatus(event: any) {
        this.selectedRef = null;
        this.referralFilter.referralStatusID = event;
        this.referralsFilter = this.referrals.filter(x => x.enumReferralStatusID === this.referralFilter.referralStatusID);
    }

    updateReferralInsurance(event: TdoDropdownModel) {
    // first validate that referral doctor is created or selected
        if (this.matchReferralPatient !== true) {
            this.uiService.displayMessage('error','Please, Select or Create a new Referral Patient');
            return;
        }
        this.matchReferralInsurance = true;
    }

    setAppointmentDuration(event: TdoDropdownModel) {
        this.appointmentDuration = event.value;
    }

    changeFilter(event: InputEvent) {
        event.stopPropagation();
        if (this.referralSearch.length >= 3 || this.referralSearch.length === 0) {
            this.selectedRef = null;
            this.referralFilter.providorDoctorName = this.referralFilter.referralPatientName = this.referralFilter.referringDrName = this.referralSearch.toLowerCase();
            const referralDocFilterList = this.referringDocs.filter(x => x.FullName.toLowerCase().includes(this.referralFilter.referringDrName)).map(p => p.RefDoctorID);
            const TDOProvidersFilterList = this.listTDOProvidersDoctors.filter(x => (x.dataContact.FirstName !== null && x.dataContact.FirstName.toLowerCase().includes(this.referralFilter.referringDrName)) || (x.dataContact.LastName !== null && x.dataContact.LastName.toLowerCase().includes(this.referralFilter.referringDrName))).map(p => p.DoctorId);
            this.referralsFilter = this.referrals.filter(x => (referralDocFilterList.includes(x.RefDoctorID) || TDOProvidersFilterList.includes(x.ProviderID) || x.Patient_FirstName.toLowerCase().includes(this.referralFilter.referralPatientName) || x.Patient_LastName.toLowerCase().includes(this.referralFilter.referralPatientName)) && x.enumReferralStatusID === this.referralFilter.referralStatusID);
        }
    }

    // appointments
    createByCalendar() {
        const dialogData = {
            patientId: this.validTDOXpatientID,
            referralDoctorId: this.dataReferralDoctor.DoctorId,
            isAppointmentByReferral: true
        };
        // validate that fields are correct
        if (this.matchReferralPatient) {
            this.dialogService.setData(dialogData);
            const dialogRef = this.dialog.open(SchedulerComponent, {
                width: '80%',
                height: '80%',
                panelClass: 'dialog'
            }).afterClosed().subscribe((res) => {
            });
        } else {
            this.uiService.displayMessage('error','Please, Select or Create Patient');
            return;
        }
    }

    createAppointment() {
    // validate if appointment can be created
        if (this.selectedRef.enumReferralStatusID === EnumReferralStatus.Pending) { // only Pending referrals request
            if (!this.matchReferralPatient || !this.matchReferralDoctor) {
                this.dialogService.openConfirmDialog('Please, Select or Create a new Referral Doc / Patient',
                    false, false, 'Referral Management').subscribe((result) => {
                    if (result === true) {
                        return;
                    }
                });
            } else { // referral Provider and Patient have been created
                //  global object to transfer
                const AppNotes = this.selectedRef.ReferralTretmentIDsJSON.split(' ').map(x => this.procedures.find(p => p.ReferralTretmentID === x)?.ItemName || '').join(', ');
                const ProviderDoc = this.listTDOProvidersDoctors.find(x => x.DoctorId === this.selectedRef.ProviderID).dataContact;
                this.globals.ReferralAppointmentRequest = {
                    ReferralId: this.selectedRef.ReferralID,
                    ReferralDoctorFullName: this.selectedDoc.FullName,
                    ReferralDoctorID: this.dataReferralDoctor.DoctorId,
                    PatientFullName: this.selectedRef.Patient_FirstName + ' ' + this.selectedRef.Patient_LastName,
                    PatientID: this.validTDOXpatientID,
                    ProviderFullName: `${ProviderDoc.FirstName} ${ProviderDoc.LastName}`,
                    ProviderId: this.selectedRef.ProviderID,
                    Teeth: this.selectedRef.ToothIDsJSON,
                    AppNotes,
                    Notes: this.selectedRef.Notes,
                    ReferralNotes: `Referring Doctor: ${this.selectedDoc.FullName}, email:  ${this.selectedDoc.email} , phone:  ${this.selectedDoc.phone}
                    Patient: ${this.selectedRef.Patient_FirstName} ${this.selectedRef.Patient_LastName}  email:  ${this.selectedRef.Patient_email},
                    phone:  ${this.selectedRef.Patient_phone}, insurance info:  ${this.selectedRef.Insurance_Company},  ${this.selectedRef.Insurance_Number},
                    Treatments:  ${AppNotes}, Teeth:${this.selectedRef.ToothIDsJSON},
                    Notes: ${this.selectedRef.Notes}`,
                };
                // open calendar
                this.uiService.openSchedulerWindow();
            }
        }
    }

    getIconByEnumType(enumScheduleType:
    string
    ) {
        if (enumScheduleType === Patient_Will_Contact_Office) {
            this.imageTooltip = 'Patient Will Contact Office';
            return '../../../assets/icons/icons8-phone.svg';
        } else if (enumScheduleType === Contact_Patient) {
            this.imageTooltip = 'Contact Patient';
            return '../../../assets/icons/icons8-headset.svg';
        } else if (enumScheduleType === Already_Have_Appointment) {
            this.imageTooltip = 'Already Have Appointment';
            return '../../../assets/icons/icons8-calendar.svg';
        } else {
            return '';
        }
    }

    closeSearch() {
        this.isShowPatientSearch = false;
        this.patientSearchList = [];
    }

    // patient handling section
    handlePatient(event: any) {
    // first validate that doctor is created or selected
        if (this.matchReferralDoctor !== true) {
            this.uiService.displayMessage('error','Please, Select or Create a new Referral Doctor');
            return;
        }
        const dm = new PatientDialogDataModel();
        dm.mode = PatientDialogDataModel.MODE_NEW_PATIENT;
        dm.title = 'New Patient';
        // dm.initWebId = true;
        dm.entityType = PatientDialogDataModel.TYPE_PATIENT;

        // set Patient Information
        dm.isReferralPatient = true;
        dm.ThePatient = new PatientDataModel();
        dm.ThePatient.BirthDate = this.selectedRef.Patient_DOB;
        dm.ThePatient.dataContact = new ContactDataModel();
        dm.ThePatient.dataContact.FirstName = this.selectedRef.Patient_FirstName;
        dm.ThePatient.dataContact.LastName = this.selectedRef.Patient_LastName;
        // set Contact Communication
        const PatientPhone: ContactCommsDataModel = new ContactCommsDataModel();
        PatientPhone.Address = this.selectedRef.Patient_phone;
        PatientPhone.enumCommMethodID = CommMethodEnum.Mobile;
        PatientPhone.enumCommLocationID = CommLocationEnum.HOME;
        const PatientEmail: ContactCommsDataModel = new ContactCommsDataModel();
        PatientEmail.Address = this.selectedRef.Patient_email;
        PatientEmail.enumCommMethodID = CommMethodEnum.Email;
        PatientEmail.enumCommLocationID = CommLocationEnum.HOME;
        dm.ThePatient.dataContact.dataContactComms.push(PatientPhone);
        dm.ThePatient.dataContact.dataContactComms.push(PatientEmail);
        // set Patient insurance card info
        const insuranceCardInfo = `Insurance Information-
            Name: ${this.selectedRef.Insurance_FirstName}  ${this.selectedRef.Insurance_LastName}
            DOB: ${this.datePipe.transform(this.selectedRef.Insurance_DOB, 'MM-dd-yyyy')}
            Company: ${this.selectedRef.Insurance_Company},
            Number: ${this.selectedRef.Insurance_Number}`;
        // set Patient Doctor information
        const PatientDoctor = new PatientDoctorDataModel();
        PatientDoctor.DoctorID = this.dataReferralDoctor.DoctorId;
        PatientDoctor.isReferring = true;
        PatientDoctor.DoctorSpecId = this.dataDoctorSpecialties[0].DoctorSpecId;
        dm.ThePatient.dataPatientDoctors.push(PatientDoctor);


        const config = new MatDialogConfig();
        config.width = '968px';
        config.height = '600px';
        config.panelClass = 'tdo-note-dialog-main';
        config.data = dm;

        const dialogRef = this.dialog.open(PatientEditComponent, config);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                // the dataPatientDoctor, should be saved from the patient component
                this.setCurrentPatient(result.patientId, `${result.ThePatient.dataContact.FirstName} ${result.ThePatient.dataContact.MidName} ${result.ThePatient.dataContact.LastName}`, true);
                // save note for insurance card info
                this.saveInsuranceCardInfo(result.patientId, insuranceCardInfo);
                // because it is a new patient, clear insurance match list
                this.listMatchTDOInsurances = [];
            }
        }, err => {
            this.uiService.displayMessage('error','Something went wrong when saving Patient');
            console.error('Something went wrong when saving Patient', err);
        });
    }




    saveReferralNotes(PatientId: string, note: string) {
        this.referralNote = new TdoNoteSaveModel();
        this.referralNote.text = note;

        this.referralNote.patientId = PatientId;
        const assoc = new TdoNoteAssociatedObject();
        assoc.objectId = PatientId;
        assoc.parentObjectName = 'dataPatient';
        this.referralNote.associatedObjects = [];
        this.referralNote.associatedObjects.push(assoc);
        this.referralNote.categoryEnumIds = [NoteCategoryEnum.ReferringDoctorCommunication];
        this.referralNote.typeEnumIds = [NoteTypeEnum.Patient];
        this.notesService.saveNote(this.referralNote).subscribe((res) => {

            const noteQueryModel = new TdoNoteQueryModel();
            noteQueryModel.parentObjectName = 'dataPatient';
            noteQueryModel.objectId = PatientId;
            noteQueryModel.patientId = PatientId;
            noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
            noteQueryModel.categoryEnumId = NoteCategoryEnum.ReferringDoctorCommunication;
            this.notesService.changeNoteQuery(noteQueryModel);
            this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
        });
    }

    saveInsuranceCardInfo(PatientId: string, note: string) {
        this.referralInsuranceCardNote = new TdoNoteSaveModel();
        this.referralInsuranceCardNote.text = note;

        this.referralInsuranceCardNote.patientId = PatientId;
        const assoc = new TdoNoteAssociatedObject();
        assoc.objectId = PatientId;
        // Must match the association used by the insurance card panel and the patient portal,
        // so all three write to the same note instead of creating parallel invisible ones.
        assoc.parentObjectName = 'dataPatientInsuranceCard';
        this.referralInsuranceCardNote.associatedObjects = [];
        this.referralInsuranceCardNote.associatedObjects.push(assoc);
        this.referralInsuranceCardNote.categoryEnumIds = [NoteCategoryEnum.InsuranceCardInfo];
        this.referralInsuranceCardNote.typeEnumIds = [NoteTypeEnum.Patient];
        this.notesService.saveNote(this.referralInsuranceCardNote).subscribe((res) => {

            const noteQueryModel = new TdoNoteQueryModel();
            noteQueryModel.parentObjectName = 'dataPatientInsuranceCard';
            noteQueryModel.objectId = PatientId;
            noteQueryModel.patientId = PatientId;
            noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
            noteQueryModel.categoryEnumId = NoteCategoryEnum.InsuranceCardInfo;
            this.notesService.changeNoteQuery(noteQueryModel);
            this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
        });
    }

    /* onPatientSearchInput(event:
  string
  ) {
      console.log('sss: ' + this.searchString);
  }*/

    // insurance
    handleInsurance(event: any) {
    // first validate that Patient is created or selected
        if (this.matchReferralPatient !== true) {
            this.uiService.displayMessage('error','Please, Select or Create a new Patient');
            return;
        }

        const dialogRef = this.dialog.open(InsuranceManagementComponent, {
            width: '80%',
            height: '80%',
            panelClass: 'dialog',
            data: {
                patientID: this.validTDOXpatientID
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {

            }
            this.getInsuranceForPatient();
            this.matchReferralInsurance = true;
        }, err => {
            this.uiService.displayMessage('error','Something went wrong when saving Insurance');
            console.error('Something went wrong when saving Insurance', err);
        });
    }

    findDrOnList(event: any) {
        const dialogRef = this.dialog.open(ReferralMatchListComponent, {
            width: '800px',
            height: '500px',
            panelClass: 'dialog',
            data: {
                isDialogMode: true,
                isReferralDoctor: true,
                Title: 'Select a Referring Doctor',
                listTDOReferralDoctor: this.listTDOReferralDoctor
            }
        }).afterClosed().subscribe((data) => {
            if (data) {
                this.updateDataReferralDoctor(data);
                // this.isMatchReferralDoctorByQuery = false;
            }
        });
    }

    updateDataReferralDoctor(data: any) {
        this.matchReferralDoctor = true;
        this.dataReferralDoctor.DoctorId = data.DoctorId;
        this.dataDoctorSpecialties = data.dataDoctorSpecialties;
        this.dataReferralDoctor.FullName = (data.dataContact.FirstName !== null ? data.dataContact.FirstName : '') + ' ' +
      (data.dataContact.MidName !== null ? data.dataContact.MidName : '') + ' ' +
      (data.dataContact.LastName !== null ? data.dataContact.LastName : '');
        this.apiService.saveDataReferralDoctor(this.dataReferralDoctor).subscribe();
        if (this.matchReferralPatient) { // if patient Match before than doctor, save dataPatientDoctor after adding Referral Doctor
            this.updateDataPatientDoctorRecord();
        }

    }

    selectPatient(Patient: PatientSearchModel) {
        this.isShowPatientSearch = false;
        this.setCurrentPatient(Patient.PatientId, `${Patient.FirstName} ${Patient.MidName} ${Patient.LastName}`, true);
    }

    // create new Referral DataDoctor
    createReferringDoctor(event: any) {
        const dialogData = {
            FirstName: this.selectedDoc.FullName.split(' ')[0],
            LastName: this.selectedDoc.FullName.split(' ')[1],
            phone: this.selectedDoc.phone,
            email: this.selectedDoc.email,
            isNewReferralFromFrontDesk: true
        };
        this.dialogService.openConfirmDialog(`Please Confirm you want to create New Referral Doctor  ${this.selectedDoc.FullName}`).subscribe((result) => {
            if (result === true) {
                this.dialogService.setData(dialogData);
                // console.log('createReferringDoctor:', dialogData);
                const dialogRef = this.dialog.open(DoctorsComponent, {
                    width: '60%',
                    height: '85%',
                    panelClass: 'dialog'
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this.updateDataReferralDoctor(result);
                        // this.isMatchReferralDoctorByQuery = false;
                    }
                }, err => {
                    this.uiService.displayMessage('error','Something went wrong when saving Doctor');
                    console.error('Something went wrong when saving Doctor', err);
                });
            } else {
                this.uiService.displayMessage('error','New Referral Doctor did not save');
            }
        });
    }

    onClickAddNoteToPatient() {
        // this.selectedRef.DiscomfortLevel
        // selectedRef.Notes

        if (this.validTDOXpatientID) {


            let s = '';

            s+= 'Referred By: ' + this.selectedDoc.FullName + '\r\n';
            s+= 'Email: '+this.selectedDoc.email + '\r\n';
            
            s += 'Teeth: ' + this.selectedRef.ToothIDsJSON + '\r\n';
            
            if(this.treatmentsSelected.length > 0) {
                s += 'Treatments: \r\n';
                this.procedures.forEach(p => {
                    if (this.treatmentsSelected.includes(p.ReferralTretmentID)) {
                        s += '- '+ p.ItemName + '\r\n';
                    }
                });
            }

                        
            if(this.othTreatments.length > 0) {
                s += 'Other Treatments: \r\n';
                this.otherServices.forEach(t => {
                    if (this.othTreatments.includes(t.ReferralOtherID)) {
                        s += '- '+ t.ItemName + '\r\n';
                    }
                });

            }



            
            s +='Discomfort:' + this.selectedRef.DiscomfortLevel + '\r\n';
            s +='Notes: '+ this.selectedRef.Notes;

            this.saveReferralNotes(this.validTDOXpatientID, s);

        }
        else {
          this.uiService.displayMessage('warning','No Patient selected');
        }

    }

    ngOnDestroy() {
        this.globals.validTDOXpatientID = null;
    }
}



